import logo from './logo.png';

export const TENANT_CONFIG = {
  name: '',
  logo: logo,
  logoWidth: 'auto',
  logoHeight: 30,
  
  // Login page configuration
  login: {
    title: 'AppEsteem Inspector',
    subtitle: 'Welcome to AppEsteem - Sign in to continue',
    logo: logo
  },
  
  // Feature flags
  features: {
    azureBrowser: true,
    firebaseBrowser: true,
    firestoreBrowser: true,
    deviceAuth: true,
    videoTimeline: true,
    hintsPanel: true,
    inspection: true,
    userManagement: true,
    fileUpload: true,
    realTimeUpdates: true
  },
  
  // Module configurations
  modules: {
    inspection: {
      enabled: true,
      statuses: ['Pending', 'InProgress', 'Completed', 'Failed'],
      results: ['Passed', 'Failed', 'Warning', 'Error'],
      maxFileSize: '100MB',
      allowedTypes: ['.exe', '.msi', '.dmg', '.pkg']
    },
    userManagement: {
      enabled: true,
      roles: ['admin', 'editor', 'viewer'],
      autoCreateCompany: true
    }
  },
  
  // UI customization
  theme: {
    primaryColor: '#1976d2',
    logoPosition: 'left'
  },
  
  firebase: {
    projectId: "three-clicks-inspect",
    authDomain: "inspect.threeclicks.ai",
    storageBucket: "three-clicks-inspect.firebasestorage.app"
  },
  
  // AutoWatch configuration
  autowatch: {
    serverUrl: 'https://api.threeclicks.ai'
  }
};
